import React, { useEffect, useState } from 'react';
import { MediaInfo } from './types.js';
import { MediaLightbox } from './MediaLightbox.js';
import { MediaFallback } from './MediaFallback.js';
import { isLocalMediaUrl, markImageAsFailed } from '../../../../../utils/failedImageCache';

interface ImageMediaProps {
    media: MediaInfo;
    status?: string;
}

/** Renderiza imagem do chat; URLs efêmeras já são filtradas em MessageMedia. */
export const ImageMedia: React.FC<ImageMediaProps> = ({ media, status }) => {
    const url = media.url;
    const [showLightbox, setShowLightbox] = useState(false);
    const [hasError, setHasError] = useState(() => !url);

    useEffect(() => {
        setHasError(!url);
    }, [url]);

    const handleImgError = () => {
        // Blob revogado no swap R2 → não marcar falha nem forçar “indisponível”.
        if (isLocalMediaUrl(url)) {
            setHasError(true);
            return;
        }
        if (url) markImageAsFailed(url);
        setHasError(true);
    };

    if (!url || hasError) {
        // Nunca defaultar failed: status undefined → “Carregando…” (não “indisponível”).
        return <MediaFallback type="image" status={status} />;
    }

    return (
        <>
            <div className="max-w-xs cursor-pointer" onClick={() => setShowLightbox(true)}>
                <img
                    src={url}
                    alt="Imagem"
                    className="w-full h-auto object-cover max-h-80 hover:opacity-95 transition-opacity rounded-lg"
                    loading="lazy"
                    decoding="async"
                    referrerPolicy="no-referrer"
                    onError={handleImgError}
                />
            </div>
            {showLightbox && (
                <MediaLightbox
                    items={[{ url, type: 'image' }]}
                    initialIndex={0}
                    onClose={() => setShowLightbox(false)}
                />
            )}
        </>
    );
};
